import { Outlet } from 'react-router-dom'
import { AppShell, type NavGroup } from './AppShell'
import { useLocaleSync } from '../i18n/useLocaleSync'

// Content creators get the full analytics + account dashboard.
const CREATOR_NAV_GROUPS = [
  {
    groupKey: 'shell.groupAnalytics',
    items: [
      { to: '/dashboard', labelKey: 'shell.navPanel' },
      { to: '/stats', labelKey: 'shell.navStats' },
      { to: '/audio', labelKey: 'shell.navContent' },
      { to: '/income', labelKey: 'shell.navIncome' },
    ],
  },
  {
    groupKey: 'shell.groupAccount',
    items: [
      { to: '/profile', labelKey: 'shell.navProfile' },
      { to: '/data', labelKey: 'shell.navData' },
      { to: '/settings', labelKey: 'shell.navSettings' },
    ],
  },
] as const satisfies readonly NavGroup[]

export function AppShellLayout() {
  useLocaleSync()
  return (
    <AppShell navGroups={CREATOR_NAV_GROUPS}>
      <Outlet />
    </AppShell>
  )
}
